import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import routes from "../routes";

const { SubMenu } = Menu;

const MobileDrawerMenu = ({ closeDrawer }) => {
  const location = useLocation();

  const selectedKey = `/${location.pathname.split("/")[1]}`;

  return (
    <Menu
      mode="inline"
      selectedKeys={[location.pathname]}
      defaultOpenKeys={[selectedKey]}
      style={{ borderRight: 0 }}
    >
      {routes
        .filter(route => route.showInHeader || route.showin_more)
        .map(route => {
          const hasSubMenu = route.SubMenu && route.subMenus?.length > 0;

          if (hasSubMenu) {
            return (
              <SubMenu
                key={route.path}
                icon={route.imageMobile && <img src={route.imageMobile} alt="" width={16} />}
                title={route.label}
              >
                {route.subMenus
                  .filter(sub => sub.label && sub.hideSideMenu !== true)
                  .map(sub => (
                    <Menu.Item
                      key={`${route.path}${sub.path}`}
                      onClick={closeDrawer}
                    >
                      <Link to={`${route.path}${sub.path}`}>
                        {sub.label}
                      </Link>
                    </Menu.Item>
                  ))}
              </SubMenu>
            );
          }

          return (
            <Menu.Item
              key={route.path}
              icon={route.imageMobile && <img src={route.imageMobile} alt="" width={16} />}
              onClick={closeDrawer}
            >
              <Link to={route.path}>{route.label}</Link>
            </Menu.Item>
          );
        })}
    </Menu>
  );
};

export default MobileDrawerMenu;
